(function () {
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'jw-toast';
    t.innerHTML = '<span></span><a href="/cart">View bag</a>';
    t.firstChild.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
  function refreshCartIcon() {
    try {
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !s['cart-icon-bubble']) return;
        var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (d) el.innerHTML = d.innerHTML;
      }).catch(function () {});
    } catch (e) {}
  }
  function setLabel(card, text) {
    var lab = card.querySelector('.jw-pc__lab');
    if (lab && text) lab.textContent = text;
  }
  function applyDot(card, dot, swapImage) {
    var p = card.querySelector('.jw-pc__price');
    if (p) {
      var html = (dot.getAttribute('data-from') ? 'From ' : '') + dot.getAttribute('data-price');
      if (dot.getAttribute('data-compare')) html += '<s>' + dot.getAttribute('data-compare') + '</s>';
      p.innerHTML = html;
    }
    setLabel(card, dot.getAttribute('data-name'));
    var url = dot.getAttribute('data-url');
    if (url) card.querySelectorAll('a.jw-pc__media, a.jw-pc__name, a.jw-pc__add').forEach(function (a) { a.setAttribute('href', url); });
    if (swapImage) {
      var m = card.querySelector('.jw-pc__media');
      var img = m && m.querySelector('img');
      var src = dot.getAttribute('data-img');
      if (img && src) {
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
        m.classList.add('is-swapped');
      }
    }
  }
  function initCards(scope) {
    (scope || document).querySelectorAll('.jw-pc').forEach(function (card) {
      if (card.__jwSw) return;
      card.__jwSw = true;
      var on = card.querySelector('.jw-pc__dot.is-on');
      if (on) applyDot(card, on, false);
    });
  }
  if (!window.__jwColGlobal) {
    window.__jwColGlobal = true;
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('.jw-pc__dot');
      if (dot) setLabel(dot.closest('.jw-pc'), dot.getAttribute('data-name'));
    });
    document.addEventListener('mouseout', function (e) {
      var dot = e.target.closest && e.target.closest('.jw-pc__dot');
      if (!dot) return;
      var card = dot.closest('.jw-pc');
      var on = card.querySelector('.jw-pc__dot.is-on');
      if (on) setLabel(card, on.getAttribute('data-name'));
    });
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.jw-pc__dot');
      if (dot) {
        e.preventDefault();
        var card = dot.closest('.jw-pc');
        card.querySelectorAll('.jw-pc__dot').forEach(function (d) {
          d.classList.toggle('is-on', d === dot);
          d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
        });
        applyDot(card, dot, true);
        return;
      }
      var b = e.target.closest('button.jw-pc__add[data-add]');
      if (!b) return;
      e.preventDefault();
      var old = b.innerHTML;
      b.disabled = true;
      b.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-add')), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          b.textContent = 'Added';
          toast('Added to your bag');
          refreshCartIcon();
          setTimeout(function () { b.innerHTML = old; b.disabled = false; }, 2500);
        })
        .catch(function () { b.innerHTML = old; b.disabled = false; window.location.href = '/cart'; });
    });
  }
  function init(root) {
    if (root.__jwCol) return;
    root.__jwCol = true;
    var form = root.querySelector('[data-jw-form]');
    var drawer = root.querySelector('[data-jw-drawer]');
    var timer = null;
    function submit() { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    initCards(root);
    root.addEventListener('click', function (e) {
      if (drawer && e.target === drawer) { drawer.close(); return; }
      if (e.target.closest('[data-jw-open]')) { if (drawer && drawer.showModal) drawer.showModal(); return; }
      if (e.target.closest('[data-jw-close]')) { if (drawer) drawer.close(); }
    });
    root.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp.matches) return;
      if (inp.matches('input[data-k]')) {
        root.querySelectorAll('input[data-k]').forEach(function (o) {
          if (o !== inp && o.getAttribute('data-k') === inp.getAttribute('data-k')) o.checked = inp.checked;
        });
        if (inp.closest('.jw-col__side')) { clearTimeout(timer); timer = setTimeout(submit, 300); }
      } else if (inp.matches('input[type=number]')) {
        root.querySelectorAll('input[type=number]').forEach(function (o) {
          if (o !== inp && o.name === inp.name) o.value = inp.value;
        });
        if (inp.closest('.jw-col__side')) { clearTimeout(timer); timer = setTimeout(submit, 300); }
      }
    });
    var sort = root.querySelector('[data-jw-sort]');
    if (sort && form) sort.addEventListener('change', submit);
    if (form) {
      form.addEventListener('submit', function () {
        var seen = {};
        form.querySelectorAll('input[data-k]').forEach(function (i) {
          if (!i.checked) return;
          var k = i.getAttribute('data-k');
          if (seen[k]) i.disabled = true; else seen[k] = true;
        });
        var seenN = {};
        form.querySelectorAll('input[type=number]').forEach(function (i) {
          if (!i.value || seenN[i.name]) { i.disabled = true; } else { seenN[i.name] = true; }
        });
      });
    }
    var more = root.querySelector('[data-jw-more]');
    var grid = root.querySelector('[data-jw-grid]');
    var shown = root.querySelector('[data-jw-shown]');
    if (more && grid) {
      var box = more.parentNode;
      var io = null;
      var label = more.textContent;
      var loading = false;
      var load = function () {
        var url = more.getAttribute('data-next');
        if (!url || loading || !more.isConnected) return;
        loading = true;
        more.disabled = true;
        more.textContent = 'Loading more...';
        fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (t) {
          var d = new DOMParser().parseFromString(t, 'text/html');
          d.querySelectorAll('[data-jw-grid] > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          initCards(grid);
          var nm = d.querySelector('[data-jw-more]');
          loading = false;
          if (nm && nm.getAttribute('data-next')) {
            more.setAttribute('data-next', nm.getAttribute('data-next'));
            more.disabled = false;
            more.textContent = label;
            if (io) { io.unobserve(box); io.observe(box); }
          } else {
            more.remove();
            if (io) io.disconnect();
          }
          if (shown) shown.textContent = grid.children.length;
        }).catch(function () { window.location.href = url; });
      };
      more.addEventListener('click', load);
      if ('IntersectionObserver' in window) {
        box.classList.add('is-auto');
        io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) load();
        }, { rootMargin: '800px 0px' });
        io.observe(box);
      }
    }
  }
  function initAll() { document.querySelectorAll('[data-jw-col]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();